/* Types */
import { YMMethod } from '@/services/metrics/types/scripts.types'

// Создаем функцию вызова скрипта метрики для отправки данных
export const injectionProvider = (id?: string): YMMethod => {
  return (...arguments_: any) => {
    if (!id) return

    try {
      window.ym(id, ...arguments_)
    } catch {
      console.warn(`не удалось вызвать функцию ym, счетчик ${id}`)
    }
  }
}

export const initVendorYandexMetrics = async (setupVendorYandex: any) => {
  try {
    await setupVendorYandex(window, document)
  } catch (error) {
    const { $sentryCaptureException }: any = useNuxtApp()

    $sentryCaptureException(error)
    console.warn(error)
  }
}
